(function (angular) {
    'use strict';

    angular.module('chat2')
        /**
         *
         */
        .controller('addTeamModal', ['$scope', '$stateParams', 'teamSettingsService', '$uibModalInstance', 'growlService', 'id',
            function ($scope, $stateParams, teamSettingsService, $uibModalInstance, growlService, id) {
                $scope.save = function () {
                    var data = {
                        name: $scope.name
                    };
                    teamSettingsService.createTeam(id, data)
                        .then(function (result) {
                            $uibModalInstance.close(result);
                        })
                        .catch(function (error) {
                            growlService.danger("Team wasn't created due to: " + error.statusText);
                        });
                };
                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }])
})(window.angular);